<template>
  <div class="page-container">
    <h1 class="display-1">Trivio</h1>

    <!-- Quiz starten -->
    <router-link class="router-link" to="/quiz">
      <button type="button" class="btn btn-lg">Start Quiz</button>
    </router-link>

    <!-- Intro -->
    <router-link class="router-link" to="/about">
      <button type="button" class="btn btn-lg">How to play</button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "HomePage",
  methods: {},
};
</script>

<style scoped>
.page-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

h1 {
  margin-bottom: 2rem;
}

.btn {
  width: 200px;
  padding: 10px;
  margin: 10px;
  background-color: #333;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 1.2rem;
  cursor: pointer;
}

.router-link {
  color: white;
  text-decoration: none;
}

.btn:hover {
  background-color: #555;
}

@media only screen and (max-width: 600px) {
  .display-1 {
    font-size: calc(5.625rem + 4.5vw);
  }

  .btn {
    font-size: 1.5rem;
  }
}
</style>
